import React from 'react';
import R from 'ramda';
import { connect } from 'react-redux';
import { Checkbox } from 'material-ui';
import SingleProduct from './single-product.jsx';
import { checkIfProductWithNothingToShow } from '../../../../../utils/mass-rate-change-helpers';

const ActionAreaProducts = ({ rateType, updateType, notApplyToExtraChild, onChangeNotApplyTo, ...updateCategories }) => {
  const updateData = updateCategories[updateType];
  const filteredProducts = R.reject(checkIfProductWithNothingToShow(updateType, rateType), R.propOr([], 'products')(updateData));

  const showNotApplyToExtraChildCheckbox = Boolean(rateType === 'nett' || rateType === 'commission');
  if (R.isEmpty(filteredProducts)) return <div style={{ padding: '24px', textAlign: 'center' }}>There is no rates under this category.</div>;
  return (
    <div>
      {
        filteredProducts.length && filteredProducts.length > 1 ? <SingleProduct applyAll noBottomBorder={showNotApplyToExtraChildCheckbox} /> : <div/>
      }
      <div style={{ display: showNotApplyToExtraChildCheckbox ? 'block' : 'none', borderBottom: 'solid 1px #eeeeee' }}>
        <Checkbox onCheck={onChangeNotApplyTo} checked={notApplyToExtraChild} label="Do not apply to Extra Adult/Child" labelStyle={{ color: 'rdga(0, 0, 0, 0.54)' }} style={{ marginTop: '6px', marginBottom: '6px', marginLeft: '28px' }} />
      </div>
      {
        R.call(R.compose(
          products => products.map((product, index) => <SingleProduct key={index} {...product} />),
          R.flatten,
          R.values,
          R.groupBy(R.prop('productId'))
        ), filteredProducts)
      }
    </div>
  );
};

const mapStateToProps = ({ contracting }) => ({
  notApplyToExtraChild: contracting.massRateChange.getIn([contracting.massRateChange.get('updateType'), `notApplyToExtraChildFor${contracting.massRateChange.get('rateType')}`]),
  rateType: contracting.massRateChange.get('rateType'),
  updateType: contracting.massRateChange.get('updateType'),
  seasonRates: contracting.massRateChange.get('seasonRates').toJS(),
  offers: contracting.massRateChange.get('offers').toJS(),
  extras: contracting.massRateChange.get('extras').toJS(),
});

export default connect(mapStateToProps)(ActionAreaProducts);



// WEBPACK FOOTER //
// ./src/app/components/contracting/mass-rate-change/middle-action-area/products/products.jsx